import React from 'react';

export default function Toggle() {
  return <></>;
}
